module.exports = __webpack_public_path__ + "img/layout_ladder.5b518a1e.svg";